import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import Navbar from "@/components/Navbar";
import SocialBar from "@/components/SocialBar";
import Footer from "@/components/Footer";
import JoinTheVibe from "@/components/JoinTheVibe";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import HighOnLifePage from "@/pages/HighOnLifePage";
import BlogPostPage from "@/pages/BlogPostPage";
import ClothingPage from "@/pages/ClothingPage";
import HairPage from "@/pages/HairPage";
import CommunityPage from "@/pages/CommunityPage";
import WorkWithMePage from "@/pages/WorkWithMePage";
import ContactPage from "@/pages/ContactPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import CurlScanPage from "@/pages/CurlScanPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ProductsPage from "@/pages/ProductsPage";
import SASPage from "@/pages/SASPage";
import CurlQuizPage from "@/pages/CurlQuizPage";
import DeliveryPage from "@/pages/DeliveryPage";
import ReturnsPage from "@/pages/ReturnsPage";
import FAQPage from "@/pages/FAQPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import AdminPage from "@/pages/AdminPage";
import "@/App.css";

function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id SYNCHRONOUSLY during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <div className="min-h-screen bg-sand font-body text-ocean">
      <SocialBar />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/high-on-life" element={<HighOnLifePage />} />
          <Route path="/high-on-life/:postId" element={<BlogPostPage />} />
          <Route path="/clothing" element={<ClothingPage />} />
          <Route path="/hair" element={<HairPage />} />
          <Route path="/community" element={<CommunityPage />} />
          <Route path="/work-with-me" element={<WorkWithMePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/curlscan" element={<CurlScanPage />} />
          <Route path="/donate" element={<Navigate to="/surfers-against-sewage" replace />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/surfers-against-sewage" element={<SASPage />} />
          <Route path="/events" element={<Navigate to="/community" replace />} />
          <Route path="/curl-quiz" element={<CurlQuizPage />} />
          <Route path="/delivery" element={<DeliveryPage />} />
          <Route path="/returns" element={<ReturnsPage />} />
          <Route path="/faqs" element={<FAQPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          {/* Legacy redirects */}
          <Route path="/blog" element={<HighOnLifePage />} />
          <Route path="/blog/:postId" element={<BlogPostPage />} />
          <Route path="/style" element={<ClothingPage />} />
        </Routes>
      </main>
      <JoinTheVibe />
      <Footer />
      <Toaster />
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
